module.exports = __webpack_public_path__ + "static/media/sbb-thumbnail.bf0772ad.jpg";